import script from "./SeasonBusinessUnitsWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./SeasonBusinessUnitsWidget.vue?vue&type=script&setup=true&lang=js"

import "./SeasonBusinessUnitsWidget.vue?vue&type=style&index=0&id=1a771153&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a771153"]])

export default __exports__